export default __webpack_public_path__ + "static/media/notification-sound-new.0fb17c89.wav";